import { filterClasses } from "@swivl-mono/helpers";
import { ReactNode } from "react";

interface HelperTextProps {
  children: ReactNode;
  className?: string;
}

export function HelperText({ children, className }: HelperTextProps) {
  if (!children) return null;

  return <p className={filterClasses("body-sm mt-0.5 text-grey-600", className)}>{children}</p>;
}
